import { PublicClientApplication } from "@azure/msal-browser";
import { useNavigate } from "react-router-dom"
import { onboardingMsalConfig } from "../../authConfig";
import { useEffect } from "react";
import { logAppError } from "../../utils/logActions";
import { Box, LinearProgress } from "@mui/material";
import colors from "../../scss/colors";
import { useMsal } from "@azure/msal-react";


const OnboardingInteraction = () => {
    const navigate = useNavigate();
    const msalInstance = new PublicClientApplication(onboardingMsalConfig);
    const { instance } = useMsal();

    useEffect(() => {
        const handleAuth = async () => {
            try {
                await msalInstance.initialize();

                const response = await msalInstance.handleRedirectPromise();
                const userEmail = instance.getAllAccounts()[0]?.idTokenClaims?.email;
                if (response) {
                    navigate('/dashboard/tifo');
                } else {
                    const loginRequest = {
                        scopes: ["openid", "profile"],
                        loginHint: userEmail,
                        redirectUri: `${window.location.origin}/onboardingInteraction`,
                    };
                    await msalInstance.loginRedirect(loginRequest);
                }
            } catch (error) {
                console.error("Authentication errorr:", error);
                logAppError("onboardingInteraction", "Authentication error", error);
            }
        };
        handleAuth();
    }, []);

    return (
        <div>
            <LinearProgress
                variant="indeterminate"
                color="inherit"
                sx={{
                    m: 1,
                    width: "100%",
                    position: "absolute",
                    top: "57px",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: colors.LIGHTER_BLUE,
                    "& .MuiLinearProgress-bar": {
                        backgroundColor: colors.LIGHT_BLUE,
                    },
                }}
            />
            <Box
                sx={{
                    m: 1,
                    position: "absolute",
                    top: "120px",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "100%",
                }}
            >
                <div className="flex justify-center items-center text-navy-blue font-medium text-xl relative z-10 animate-pulse w-full">
                    Connecting to Onboarding Experience...
                </div>
            </Box>
        </div>
    )
}

export default OnboardingInteraction;